<div class="container my-4">
	<div *ngFor="let app of apps; let i = index">
		<div class="app-section" *ngIf="selectedAppContent ===i ">
			<div class="col d-flex align-items-center">
				<div class="app-title">
					<h4 class="app-title-h4">
						{{app?.title}}
					</h4>
				</div>
				<!-- <div>
					<p placement="top" ngbTooltip="Updated Date">{{app?.updated_at | date:'mediumDate'}}</p>
				</div> -->
			
	
			</div>
			<div *ngIf="app?.type === 'image'">
				<!-- Display image content -->
				<img width="100%" [src]="s3MediaUrl+app?.content" alt="Image" />
			</div>
			<div *ngIf="app?.type === 'video'&&!app.isurl_link">
				<!-- Display video content -->
				<video width="100%" [src]="s3MediaUrl+app?.content" controls></video>
			</div>
			<div *ngIf="app?.type === 'video'&& app.isurl_link ">
				<!-- Display video content -->
				<div [innerHTML]="app.url_link | safeHtml"></div>
				<!-- {{formatHtmlapp?.url_link }} -->
			</div>
			<div *ngIf="app?.type === 'text'">
				<!-- Display markdown text content -->
				<div [innerHTML]="app?.content | safeHtml"></div>
			</div>
			<!-- <div>
				<i [ngClass]="isConnected(app?._id)?'fa fa-x cursor':'fa fa-link cursor'" title="Disconnect app"
					(click)="connectDisconnect(app?._id)"></i>
				<i class="fa fa-edit cursor ml-2" data-toggle="modal" data-target="#app-model" (click)="editApp(app)"></i>
			</div> -->
	
			<div class="row p-2">
				<div class="btn btn-outline-primary ml-2" *ngFor="let resource of app.resources">
					<a [href]="s3MediaUrl+resource.documents" target="_blank">{{resource?.content}}</a>
					<i class="fa fa-x cursor danger font-large float-right"></i>
				</div>
			</div>
	
		</div>
	</div>
</div>

<!-- =================== -->

<div *ngIf="current_data">
	
	  <div class="modal-header">
		<div class="d-flex align-items-center">
		  <!-- Display the type with a custom chip -->
		  <span *ngIf="current_data?.type" class="type-chip bg-light-info mr-1">
			Type:<span class="bg-light-primary badge badge-pill m-1 text-uppercase">{{ current_data?.type | titlecase }}</span> 
		  </span>
		
		  <!-- Loop through each domain in current_data and display it -->
			<span *ngIf="current_data?.domain?.length>0" class="type-chip bg-light-secondary domain-chip mr-1">
			  Domains:<span  *ngFor="let item of current_data?.domain;let i = index" class="bg-light-primary badge badge-pill m-1">{{ item?.displayname }}</span>
			</span>
		</div>
	  </div>
	  <div class="modal-body">
		<table>
		  <tr>
			<td class="title"><b><h4>{{current_data?.name}}</h4></b>
			  <span *ngFor="let item of current_data?.category">
				<span class="type-chip bg-light-primary badge badge-pill">{{item.name | titlecase}}</span>
			  </span>
		  </td>
		  </tr>
		  <tr >
			<td class="d-flex justify-content-between">
			  <span class="ml-3" [innerHTML]="current_data?.notes"></span> 
			</td>
		  </tr>
		 
		  <tr >
			<td  class="heading"><b>Skill Keywords :</b>
			  <span   class="collapse-content mt-3 ml-3">
				<span *ngFor="let skill of current_data?.skill_keywords; last as isLast">
				  <span class="bg-light-info badge badge-pill mr-1 mb-1">{{skill}}</span>
				</span>
			</span></td>
		  </tr>
		  <tr >
			<td class="heading"><b>Features Keywords :</b> <span class="keyword-buttons">
			  <span class="collapse-content mt-3  ml-3">
				<span *ngFor="let feature of current_data?.features_keywords; last as isLast">
				  <span class="bg-light-warning badge badge-pill mr-1 mb-1">{{feature}}</span>
				</span>
			  </span>
			</span></td>
			
		  </tr>
		  <tr>
			<td  class="heading"><b>Projects Keywords :</b>
			  <span class="collapse-content mt-3  ml-3">
				<span *ngFor="let project of current_data?.projects_keywords; last as isLast">
				  <span class="bg-light-secondary badge badge-pill mr-1 mb-1">{{project}}</span>
				</span>
			</span></td>
		  </tr>     
		</table>
	  </div>
  
  
  </div>